import { Container, Grid, Tab, Tabs, styled } from "@mui/material";

import { useParams, useSearchParams } from "react-router-dom";

import BoxPortfolioTradeCoin from "./Component/BoxPortfolioTradeCoin";
import TablePortfolioTradeCoin from "./Component/TablePortfolioTradeCoin";
import BoxPortfolioTradeCoinList from "./Component/BoxPortfolioTradeCoinList";
import TablePortfolioTradeCoinList from "./Component/TablePortfolioTradeCoinList";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { getPortfolioTradeAvgForCoin, getPortfolioTradeAvgForCoinForm, getPortfolioTradeAvgForCoinList } from "store/slices/portfolio/portfolioSlice";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";
import BackButton from "components/BackButton";
import DateSort from "../Components/PortfolioCard/Components/DateSort";
import { useMemo } from "react";
import { formatDateToJalali } from "utils/helpers/time";

function PortfolioDetails() {
  const { portfolioId, coinId } = useParams();

  const isMobileView = useIsMobileView();

  const dispatch = useDispatch();
  const portfolioForm = useSelector((state) => state.portfolio.portfolioForm?.data)

  const [searchParams, setSearchParams] = useSearchParams();
  const basketId = +searchParams.get("basket") || 0;
  const portfolioDate = +searchParams.get("portfolioDate") || 0;
  const startDate = searchParams.get("startDate") || "";

  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 5;

  const handleChangeBasket = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      basket: newValue,
    });
  };

  const allBaskets = useMemo(() => portfolioForm?.lisPortfolioChartFormDetail?.filter(p => !!p?.basketId), [portfolioForm])
  const currentPortfolioBaskets = useMemo(() => {
    const basketList = allBaskets?.filter((p) => p?.portfolioId === +portfolioId)

    return basketList

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioId, allBaskets])


  useEffect(() => {
    dispatch(getPortfolioTradeAvgForCoinForm({ basketId: basketId || "", portfolioId, coinId, dateTypeId: portfolioDate, startDate }));

    dispatch(
      getPortfolioTradeAvgForCoin({
        coinId: coinId,
        portfolioId,
        startDate,
        dateTypeId: portfolioDate,
        basketId: basketId || "",
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketId, portfolioId, coinId, portfolioDate, startDate]);


  useEffect(() => {
    dispatch(
      getPortfolioTradeAvgForCoinList({
        coinId,
        portfolioId,
        dateTypeId: portfolioDate,
        basketId: basketId || "",
        pageNumber,
        pageSize,
        startDate: formatDateToJalali(startDate),
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketId, portfolioId, coinId, portfolioDate, startDate, pageNumber, pageSize]);

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <BackButton text="Portfolio" to="/portfolio" />
        </Grid>
      </Grid>

      <DateSort />

      <Grid container spacing={2} mt={0}>
        <Grid item xs={12}>
          <TabsStyle value={basketId} onChange={handleChangeBasket}>
            <Tab label={"All"} value={0} />

            {currentPortfolioBaskets?.map((type) => (
              <Tab label={type.name} value={type.basketId} />
            ))}
          </TabsStyle>
        </Grid>
      </Grid>

      {isMobileView ? <BoxPortfolioTradeCoin /> : <TablePortfolioTradeCoin />}

      {isMobileView ? (
        <BoxPortfolioTradeCoinList />
      ) : (
        <TablePortfolioTradeCoinList />
      )}
    </Container>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
}));
export default PortfolioDetails;
